import * as React from "react";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";

interface ChangeProps {
    name: string
    unitOfMeasure?: string
    newValue: number,
    value: number,
}

export const Change: React.FC<ChangeProps> = ({newValue, value, name, unitOfMeasure}) => {
    const {AppTranslations} = React.useContext(ReadAndWriteContext);

    const getChangeText = () => {
        const change = AppTranslations.readAndWrite.changedFieldFromTo;
        const parts = change.split(/(\{0}|\{1}|\{2})/);
        return parts.map((part, index) => {
            switch (part) {
                case "{0}":
                    return <span key={index} className="font-weight-bold">{name}</span>;
                case "{1}":
                    return <span key={index} className="font-weight-bold">{value} {unitOfMeasure}</span>;
                case "{2}":
                    return <span key={index} className="font-weight-bold">{newValue} {unitOfMeasure}</span>;
                default:
                    return part;
            }
        });
}

    return <li>
        <p>
            {getChangeText()}
        </p>
    </li>
}
